<template>
    <span class="tip" :class="{message: message, link: link, warning: type=='warning'}">
        <a
            v-if="message || link || type=='warning'"
            :style="{
                cursor: (link ? 'pointer' : 'help')
            }"
            data-toggle="tooltip"
            :data-placement="placement || 'auto'"
            data-container="body"
            :title="message"
            :href="link"
            target="_blank"
        >
            <i class="fa fa-graduation-cap" v-if="link"></i>
            <i class="fa fa-exclamation-triangle" v-else-if="type=='warning'"></i>
            <i class="fas fa-lightbulb" v-else></i>
        </a>
    </span>
</template>

<script type="text/javascript">
    export default {
        props: {
            message: String,
            link: String,
            placement: String,
            type: String
        },

        mounted: function() {
            $(this.$el).children('a').tooltip();
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    // Our button
    span.tip {
        display: inline-block !important;
        vertical-align: middle;
        position: relative;
        top: -0.5em;
        padding: 0 !important;

        &.higher {
            top: -1em;
        }

        a {
            display: flex;
            align-items: center;
            justify-content: center;

            height: 18px;
            width: 14px;
            margin: 2px;
            padding: 0 !important;

            color: #999 !important;

            &:hover, &:active {
                text-decoration: none;
                background-color: transparent !important;
            }

            .fa-graduation-cap {
                font-size: 14px;
                margin: 0 !important;
            }

            .fa-lightbulb {
                font-size: 20px;
                margin: 0 !important;
            }
            .fa-exclamation-triangle {
                font-size: 20px;
                margin: 0 !important;
                color: red;
            }

        }

        &.invert {
            a {
                color: #c4c4c4 !important;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tip.vue